import React from 'react'
import'./USMap.scss'
import USmapSVG from './../../../../images/maps/us-offices-footer.inline.svg'


const USMapFooter = () => {
    return(
        <section id='usmapFooter'>
            <USmapSVG />
        </section>
    )
}


export default USMapFooter